export const environment = {
  production: true,
  appVersion: '0.1.0',
  apiUrl: 'https://api-easyloc-inte.gavicyconseil.fr',
  launcherApiUrl: 'https://api-launcher-inte.gavicyconseil.fr',
  otherAppUrl: 'https://integration.gavicyconseil.fr',
  /** Chargement de `assets/app-config.json` (réécrit au démarrage Docker). */
  useRuntimeConfig: true,
  stubAuth: false,
  stubUser: {
    sub: '',
    nom: '',
    prenom: '',
    role: '',
    orgId: 0,
    orgLibelle: '',
  },
};
